import {
    GetBrandBySlugViewModel,
    GetBrandCategoryViewModel,
    GetCategoryBySlugViewModel,
    GetTagBySlugViewModel,
} from '../../types/api'
import { CombinationSlugPageViewModel } from '../../types/cml-api'

export enum PLPPages {
    Combination = '_combination_',
    Brands = 'brands',
    Categories = 'categories',
    Search = 'search',
    Tags = 'tags',
    Facet = 'facet',
}

export type PurePLPBasicMetasProps =
    | Partial<GetBrandBySlugViewModel>
    | Partial<GetCategoryBySlugViewModel>
    | Partial<GetTagBySlugViewModel>

export type PLPBasicMetasProps = PurePLPBasicMetasProps | GetBrandCategoryViewModel | CombinationSlugPageViewModel

export type PlpSearchParams = { [key: string]: string | string[] | undefined | null }

export interface PLPPageProps {
    params?: { [key: string]: string | string[] | undefined }
    searchParams?: PlpSearchParams
}

export interface PLPBannerProps {
    params?: { [key: string]: string | string[] | undefined }
    searchParams?: PlpSearchParams
    page?: PLPPages
    basicMetas?: PLPBasicMetasProps
}

export enum PLPReactQueryKeys {
    BasicMeta = 'basic-metas',
    PLPFacets = 'plp-facets',
    PagesData = 'pages-data',
    ProductsCount = 'products-count',
    PriceRange = 'price-range',
    PLPBanner = 'plp-banner',
    CombinationsList = 'combinations-list',
}

export type PLPSlug = string | [string, string]
